import { HttpResponseError } from '../types/http-response-error';
import { HttpStatusCode } from '../types/http-status-code';
import { isResponseParsable } from './is-response-parsable';

import { vistaDiagnosticLogInstance } from '@vista-digital/occ-domain';
/**
 * Parses an HTTP response based on its status code and content type.
 *
 * @returns The parsed response content, or `undefined` if the response is not parsable. Throws an [[HttpResponseError]] if the response is not successful.
 */
export const parseHttpResponse = (response) => {
    if (response.status === HttpStatusCode.NotModified)
        return undefined; // the API would have returned OK but didn't due to a cache control header.
    if (!response.ok) {
        try {
            let errorDetails = { url: response.url };
            let errorMessage = `Http request to ${response.url} returned ${response.status}`

            // Must clone the response to allow the OCCs to still read the response details for its own error handling.
            const resultPromise = response.headers.get('content-type').includes('application/json') ? response.clone().json() : response.clone().text()
            resultPromise.then(data => {
                if (typeof data === 'string') {
                    errorDetails = { responseText: data }
                } else {
                    errorDetails = data
                }

                /**
                 * Attempt to extract the error message from connect to set as the logged message
                 */


                // Connect v1 errors
                if (data?.ErrorCode) {
                    errorMessage = `${response.url} returned ${data.ErrorCode} with status ${response.status}`
                }

                // Ocapi errors
                const message = data?.title || data?.detail || data?.type
                if (message) {
                    const url = data?.originalRequestUrl || response.url
                    errorMessage = `${url} returned ${message} with status ${response.status}`
                }

                // Only log as warning level as api failures could be expected functionality for some components.
                vistaDiagnosticLogInstance.tag('HttpClient').warn(errorMessage, errorDetails)
            });
        } catch (error) {
            // Swallow - we do not want to disrupt the original logic of this function.
        }

        throw new HttpResponseError(response);
    }
    if (!isResponseParsable(response))
        return undefined;
    const contentType = response.headers.get('content-type');
    if (contentType) {
        if (contentType.includes('application/json')) {
            return response.clone().json();
        }
        else if (contentType.includes('text/')) {
            return response.clone().text();
        }
    }
    return response.clone().blob();
};
//# sourceMappingURL=parse-http-response.js.map